import React from 'react';
import { IconBranchFill } from '@saucelabs/ds-icons';

import Truncate from '../common/Truncate';
import { DiffStatus, Scalars } from '../../graphql/__generated__/graphql';
import { formatDate, TimeMode } from '../common/DateLabel';

export const getStageStatusInfo = (
  itemStatus: DiffStatus,
  itemAuthor?: string,
  itemDate?: Scalars['Datetime'],
) => {
  switch (itemStatus) {
    case DiffStatus.Equal:
      return 'Snapshot is equal to the baseline.';
    case DiffStatus.Approved:
    case DiffStatus.Rejected:
      if (itemDate) {
        const authorInfo = itemAuthor ? ` by @${itemAuthor}` : '';
        const statusInfo = itemStatus.charAt(0) + itemStatus.substring(1).toLowerCase();
        return `${statusInfo}${authorInfo} ${formatDate[TimeMode.SHORT](itemDate)}`;
      }

      return '';
    default:
      return '';
  }
};

export type DiffStageMetaProps = {
  status: DiffStatus,
  updatedAt?: Scalars['Datetime'],
  updatedBy?: string,
  branch?: string,
  changesCounter?: number
}

const DiffStageMeta: React.FC<DiffStageMetaProps> = ({
  status,
  updatedAt,
  updatedBy,
  branch,
  changesCounter,
}) => {
  const statusInfo = getStageStatusInfo(status, updatedBy, updatedAt);

  const meta = [
    statusInfo && (
      <Truncate
        className="min-w-12"
        text={statusInfo}
        variant="body"
      />
    ),
    branch && (
      <>
        <IconBranchFill className="h-2 w-2 fill-current flex-shrink-0 mr-0.5" />
        <Truncate
          className="max-w-14 min-w-4"
          disableSpacing
          text={branch}
          variant="body"
        />
      </>
    ),
    changesCounter && (
      <Truncate
        className=""
        text={`${String(changesCounter)} changes found`}
        variant="body"
      />
    ),
  ].filter(Boolean);

  if (!meta.length) {
    return null;
  }

  return (
    <div className="flex justify-center items-center text-medium-emphasis min-w-0">
      {meta.map((item, i) => (
        <>
          {i > 0 && <span className="text-base mx-1">|</span>}
          {item}
        </>
      ))}
    </div>
  );
};

export default DiffStageMeta;
